import { Box, makeStyles, Theme, Tooltip, Typography } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { GalleryImage } from 'components/broadcast/models/gallery-image';
import { ReactElement, useState } from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useUploadedImagesStyle = makeStyles((theme: Theme): any => ({
  uploadedImages: {
    overflowX: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  thumb: {
    display: 'inline-flex',
    position: 'relative',
    margin: '10px 5px',
    width: '100px',
    height: '100px',
    boxSizing: 'border-box',
    flex: '0 0 auto',
    padding: 2,
    border: `1px solid ${theme.palette.divider}`,
  },
  thumbInner: {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  img: {
    display: 'block',
    borderRadius: 2,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    background: '#f9f9f9'
  },
  crossBtn: {
    position: 'absolute',
    cursor: 'pointer',
    top: '-10px',
    right: '-10px',
    backgroundColor: 'white',
    borderRadius: '100%',
    width: '20px',
    height: '20px',
  },
}));

export function UploadedImages({
  galleryImages,
  loading,
  onRemove,
  progressCompleted
}: {
  galleryImages: GalleryImage[];
  loading: boolean;
  onRemove(galleryImage: GalleryImage): void;
  progressCompleted: number;
}): ReactElement {
  const classes: any = useUploadedImagesStyle();
  const [previewImg, setPreviewImg] = useState<string | null>(null);

  function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2">{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }
  return (
    <Box className={classes.uploadedImages}>
      {!loading ? (
        galleryImages.map((file) => (
          <div
            className={classes.thumb}
            key={file.fileName}
            onClick={(e) => {
              if (
                file.mimeType && file.mimeType.startsWith('image/') &&
                !(e.target as HTMLElement).closest(`.${classes.crossBtn}`)
              ) {
                setPreviewImg(file.mediaUrl);
              }
            }}
            style={{ cursor: file.mimeType && file.mimeType.startsWith('image/') ? 'pointer' : 'default' }}
          >
            <div className={classes.thumbInner}>
              {file.mimeType === 'application/pdf' ? (
                <img
                  src="/pdf.png"
                  className={classes.img}
                  alt={file.fileName}
                  height="40px"
                  style={{ cursor: 'default' }}
                />
              ) : (
                <img
                  src={file.mediaUrl}
                  className={classes.img}
                  alt={file.fileName}
                />
              )}
              <Tooltip title={`Remove ${file.id}`}>
                <Box
                  className={classes.crossBtn}
                  onClick={(e): void => {
                    e.stopPropagation();
                    onRemove(file);
                  }}
                >
                  <CancelIcon style={{fontSize: '1.3rem'}}/>
                </Box>
              </Tooltip>
            </div>
          </div>
        ))
      ) : (
        <Box width="100%">
          <Typography variant="subtitle1">Uploading files</Typography>
          <LinearProgressWithLabel value={progressCompleted} />
        </Box>
      )}

      <Dialog open={!!previewImg} onClose={() => setPreviewImg(null)} maxWidth="md">
        <IconButton
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 2,
            background: 'rgba(0,0,0,0.6)',
            color: 'white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            border: '2px solid white',
            padding: 2,
            borderRadius: 20,
            width: 28,
            height: 28
          }}
          onClick={() => setPreviewImg(null)}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ padding: '40px' }}>
          {previewImg && (
            <img
              src={previewImg}
              alt="Preview"
              style={{ maxWidth: '100%', maxHeight: '80vh', display: 'block', margin: 'auto' }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
export default UploadedImages;
